module.exports = __webpack_public_path__ + "static/img/ghanshyam.a56bf5ff.jpg";